import { render } from "./AccessibilityMenu.vue?vue&type=template&id=3d4e549a"
import script from "./AccessibilityMenu.vue?vue&type=script&lang=js"
export * from "./AccessibilityMenu.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__